module.exports = __webpack_public_path__ + "img/market.9432d0d8.svg";